<script setup lang="ts">
import TabMenu from "@/components/TabMenu.vue";
import {IBaseMenuItem} from "@/models";

const props = defineProps({
  menuItems: {type: Array as () => IBaseMenuItem[], default: []},
});
</script>

<template>
  <div id="ct" class="flex-layout-body">
    <nav class="nav nav-files">
      <tab-menu :items="menuItems" :li="false" />
    </nav>
    <!-- [D] 선택 된 순서 data-file="숫자" -->
    <div class="file-content" data-file="2">
      <strong class="file-title">Operation</strong>
      <div class="file-content-hd">
        <h2 class="fs-1">서비스 영업 정보 설정</h2>
      </div>
      <form>
        <div class="fieldset d-block wide">
          <div class="row">
            <section class="col-6">
              <div class="sect-hd">
                <h4 class="fs-3">가게 영업 상태</h4>
                <p>설정된 가게 영업 시간과 관계 없이 직접 영업 상태를 변경할 수 있습니다.</p>
              </div>
              <div class="btn-check-wrap service-manage">
                <label class="btn-check">
                  <input type="radio" name="open" class="sr-only" checked>
                  <span class="btn btn-lg btn-outline-grn">
                                    <span class="badge bg-grn mr-2">영업중</span>OPEN
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.54966 18.4513L3.39746 12.2991L5.28879 10.4078L9.54966 14.6687L18.7105 5.50781L20.6019 7.39914L9.54966 18.4513Z" fill="#3DD45E"/>
                                    </svg>
                                </span>
                </label>
                <label class="btn-check">
                  <input type="radio" name="open" class="sr-only">
                  <span class="btn btn-lg btn-outline-red">
                                    <span class="badge bg-red mr-2">영업종료</span>CLOSED
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.54966 18.4513L3.39746 12.2991L5.28879 10.4078L9.54966 14.6687L18.7105 5.50781L20.6019 7.39914L9.54966 18.4513Z" fill="#FF5449"/>
                                    </svg>
                                </span>
                </label>
              </div>
            </section>
            <section class="col-6">
              <div class="sect-hd">
                <h4 class="fs-3">Work Traffic</h4>
                <p>작업 상태를 표시하기 위해 바쁨 상태를 변경해주세요.</p>
              </div>
              <div class="btn-check-wrap flex-column">
                <label class="btn-check">
                  <input type="radio" name="condition" class="sr-only">
                  <span class="btn btn-lg btn-outline-grn">
                                    <i class="dot bg-grn mr-2"></i><strong>한가함</strong>
                                    <span class="ml-3">신속한 작업이 가능합니다.</span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.54966 18.4513L3.39746 12.2991L5.28879 10.4078L9.54966 14.6687L18.7105 5.50781L20.6019 7.39914L9.54966 18.4513Z" fill="#3DD45E"/>
                                    </svg>
                                </span>
                </label>
                <label class="btn-check">
                  <input type="radio" name="condition" class="sr-only" checked>
                  <span class="btn btn-lg btn-outline-ylw">
                                    <i class="dot bg-ylw mr-2"></i><strong>작업중</strong>
                                    <span class="ml-3">순차적으로 작업이 가능합니다.</span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.54966 18.4513L3.39746 12.2991L5.28879 10.4078L9.54966 14.6687L18.7105 5.50781L20.6019 7.39914L9.54966 18.4513Z" fill="#FFBE5E"/>
                                    </svg>
                                </span>
                </label>
                <label class="btn-check">
                  <input type="radio" name="condition" class="sr-only">
                  <span class="btn btn-lg btn-outline-red">
                                    <i class="dot bg-red mr-2"></i><strong>바쁨</strong>
                                    <span class="ml-3">착수해야 할 작업이 많습니다.</span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.54966 18.4513L3.39746 12.2991L5.28879 10.4078L9.54966 14.6687L18.7105 5.50781L20.6019 7.39914L9.54966 18.4513Z" fill="##FF5449"/>
                                    </svg>
                                </span>
                </label>
              </div>
            </section>
          </div>
        </div>
        <div class="fieldset d-block wide">
          <div class="row">
            <section class="col-6">
              <div class="sect-hd">
                <h4 class="fs-3">가게 영업 시간</h4>
                <p>가게 영업 시간을 지정해주세요.<br />지정된 시간 동안 가게는 자동으로 <strong>[영업 중]</strong>으로 설정됩니다.</p>
              </div>
              <div class="flex-center">
                <input type="time" class="form-control form-control-lg" value="08:00" min="00:00">
                <span class="mx-2">-</span><input type="time" class="form-control form-control-lg" value="18:00" max="24:00">
              </div>
            </section>
            <section class="col-6">
              <div class="sect-hd">
                <h4 class="fs-3">휴가 기간 설정</h4>
                <p>장시간 휴가를 간다면, 휴가 기간을 설정해두시기 바랍니다. <br>휴가 기간 동안 가게는 자동으로 <strong>[폐점 중]</strong>으로 설정됩니다.</p>
              </div>
              <div class="input-group">
                <input class="form-control form-control-lg" type="date" />
                <span>-</span>
                <input class="form-control form-control-lg" type="date" />
                <label class="form-switch">
                  <input class="form-switch-input" type="checkbox">
                  <span class="form-switch-label">휴가 중</span>
                </label>
              </div>
            </section>
            <section class="col-6 mt-5">
              <div class="sect-hd">
                <h4 class="fs-3">가게 운영 상태</h4>
                <p>가게가 노출 정지 중이면, 주문 검색 시 노출이 되지 않습니다.</p>
              </div>
              <div class="btn-check-wrap service-manage">
                <label class="btn-check">
                  <input type="radio" name="expose" class="sr-only" checked>
                  <span class="btn btn-lg btn-outline-red">
                                    <i class="icon icon-exposure-stop mr-2"></i>노출 정지
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.54966 18.4513L3.39746 12.2991L5.28879 10.4078L9.54966 14.6687L18.7105 5.50781L20.6019 7.39914L9.54966 18.4513Z" fill="#FF5449"/>
                                    </svg>
                                </span>
                </label>
                <label class="btn-check">
                  <input type="radio" name="expose" class="sr-only">
                  <span class="btn btn-lg btn-outline-grn">
                                    <i class="icon icon-search-result mr-2"></i>검색 시 노출
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.54966 18.4513L3.39746 12.2991L5.28879 10.4078L9.54966 14.6687L18.7105 5.50781L20.6019 7.39914L9.54966 18.4513Z" fill="#3DD45E"/>
                                    </svg>
                                </span>
                </label>
              </div>
              <p class="info-txt my-3">노출 정지 중에도 진행 중인 주문 건에 대해 작업 기록을 남기실 수 있습니다.</p>
            </section>
          </div>
        </div>
        <div class="btn-wrap">
          <a href="" class="btn btn-outline">변경 취소</a>
          <button type="submit" class="btn">변경 저장</button>
        </div>
      </form>
    </div>

  </div>
</template>

<style scoped>

</style>